import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6df9a927&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeader: require('/workspace/components/organisms/BowHeader/BowHeader.vue').default,BowMap: require('/workspace/components/atoms/BowMap/BowMap.vue').default,BowCardWide: require('/workspace/components/molecules/BowCardWide/BowCardWide.vue').default,BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowCard: require('/workspace/components/molecules/BowCard/BowCard.vue').default,BowLocomotiveScrollCols: require('/workspace/components/base/BowLocomotiveScrollCols/BowLocomotiveScrollCols.vue').default,BowFilters: require('/workspace/components/molecules/BowFilters/BowFilters.vue').default,BowFiltersToggle: require('/workspace/components/atoms/BowFiltersToggle/BowFiltersToggle.vue').default,BowFooter: require('/workspace/components/organisms/BowFooter/BowFooter.vue').default})
